module.exports = __webpack_public_path__ + "green-bg-b5e27bd8b79fb6863c94ef9af137c743.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/image_generator/green-bg.jpg
// module id = 103
// module chunks = 0 1